import AppWedeliver from '@/pages/AppWedeliver/Template'
import Points from '@/pages/AppWedeliver/Points'
import Order from '@/pages/AppWedeliver/Order'
import Account from '@/pages/AppWedeliver/Account'
export default {
    path: '/appwedeliver',
    component: AppWedeliver,
    children: [
        {
            path: '',
            name: 'AppWedeliverPoints',
            component: Points,
        },
        {
            path: ':id/:id1',
            name: 'AppWedeliverOrder',
            component: Order,
        },
        {
            path: 'account',
            name: 'AppWedeliverAccount',
            component: Account,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/appwedeliver.js